import script from "./compGroupDetailAliases.vue?vue&type=script&setup=true&lang=js"
export * from "./compGroupDetailAliases.vue?vue&type=script&setup=true&lang=js"

import "./compGroupDetailAliases.vue?vue&type=style&index=0&id=023ac0ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-023ac0ae"]])

export default __exports__